import type { UnfInvoiceCandidateDto } from '@crm/shared'

const qty = (v: number): string => v.toLocaleString('ru-RU')

/** 1 позиция, 2 позиции, 5 позиций. */
export function positionsWord(n: number): string {
  const d = n % 10
  const dd = n % 100
  if (d === 1 && dd !== 11) return 'позиция'
  if (d >= 2 && d <= 4 && (dd < 12 || dd > 14)) return 'позиции'
  return 'позиций'
}

/**
 * Позиции заказа, которых нет в счёте 1С, и отметка «Будут ещё счета по этому заказу»
 * (21.10.2026). Отмечено — позиции ждут счёта; нет — уходят в «Отказ клиента» с причиной
 * «нет в счёте». Та же отметка — переключатель в карточке заказа.
 */
export function UnfInvoiceMissing({
  candidate,
  moreInvoices,
  disabled,
  onChange,
}: {
  candidate: UnfInvoiceCandidateDto
  moreInvoices: boolean
  disabled: boolean
  onChange: (value: boolean) => void
}) {
  const missing = candidate.missing
  return (
    <div className="space-y-2 rounded-lg border border-gray-200 p-3 text-sm">
      <div className="text-xs text-gray-500">
        Сравниваем с заказом: {candidate.orderPositions} {positionsWord(candidate.orderPositions)}{' '}
        со «Счётом». Позиции заявки без «Счёта» не учитываются.
      </div>
      {missing.length > 0 && (
        <div className="text-gray-700">
          Этих позиций заказа нет в счёте 1С:{' '}
          {missing.map((m) => `${m.partNumber} (${qty(m.quantity)} шт)`).join(', ')}.
        </div>
      )}
      <label className="flex items-center gap-2 text-gray-800">
        <input
          type="checkbox"
          checked={moreInvoices}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
        />
        Будут ещё счета по этому заказу
      </label>
      {missing.length > 0 && (
        <div className={moreInvoices ? 'text-gray-600' : 'text-amber-800'}>
          {moreInvoices
            ? 'Эти позиции останутся в заказе и будут ждать счёта из 1С.'
            : 'Эти позиции уйдут в «Отказ клиента» с причиной «нет в счёте».'}
        </div>
      )}
    </div>
  )
}
